"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentDrivesClaimController = /** @class */ (function () {
    function StudentDrivesClaimController($rootScope, UserService, $state, $stateParams, DrivesModel, FlashService, VueStoreFactory, drive, locations) {
        var _this = this;
        this.DrivesModel = DrivesModel;
        this.$state = $state;
        this.FlashService = FlashService;
        this.$stateParams = $stateParams;
        this.VueStoreFactory = VueStoreFactory;
        var drivePolicy = VueStoreFactory.state.policies.policies.find(function (policy) { return policy.name === 'drives'; });
        var useServiceArea = drivePolicy.policymeta.find(function (meta) { return meta.meta_key === 'use_service_area'; });
        this.pickupLocation = {};
        this.locations = locations.pickuplocations;
        this.dropofflocations = locations.dropofflocations;
        this.drive = drive;
        this.observer_or_driver = 'driver';
        if (this.drive.observation === true) {
            this.observer_or_driver = '';
        }
        this.currentUser = UserService.getCurrentUser();
        if (useServiceArea.meta_value === 'N') {
            this.drive.location = this.locations[0];
        }
        // this is the location students see if their school's settings do not allow for custom pick-up and
        // drop-off locations
        this.schoolAddress = JSON.parse(this.currentUser.school.address);
        this.submitting = false;
        $rootScope.$on('MESSAGE_CLEARED', function () {
            _this.submitting = false;
        });
        if (this.drive.type.allow_custom_dropoff_locations === false) {
            this.dropofflocation = locations.dropofflocations[0];
        }
        if (this.drive.type.allow_custom_pickup_locations === false) {
            this.pickuplocation = locations.pickuplocations[0];
        }
    }
    StudentDrivesClaimController.prototype.bookDrive = function () {
        var _this = this;
        this.submitting = true;
        var data = {
            'drive_id': this.$stateParams.id,
            'student_id': this.currentUser.id,
            'pickuplocation': this.pickuplocation,
            'dropofflocation': this.dropofflocation
        };
        if (this.drive.observation) {
            data.observer_or_driver = this.observer_or_driver;
        }
        this.DrivesModel.claimDrive(data).then(function (response) {
            _this.$state.go('drivecoach.student.dashboard', _this.$stateParams, { reload: true });
            _this.submitting = false;
            _this.FlashService.setMessage({ 'type': 'success', 'message': response.message });
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    return StudentDrivesClaimController;
}());
StudentDrivesClaimController.$inject = ['$rootScope', 'UserService', '$state', '$stateParams', 'DrivesModel', 'FlashService', 'VueStoreFactory', 'drive', 'locations'];
exports.default = StudentDrivesClaimController;
